export const MAX_REPORTS_IN_SHOPPING_CART = 100;

export enum ReportFileType {
  PDF = 0,
  PPTX = 1,
  ZIP = 2,
  XLS = 3,
  XLSX = 4,
  PPT = 5,
}

export const NO_REPORT_CONFIGURATION_VALUE = -1;
export const NO_BACKOFF_RESULT = -1;

export enum ReportOrderStatus {
  DRAFT = 0,
  ORDERED = 1,
  IN_PRODUCTION = 2,
  CREATED = 3,
  ERROR = 4,
}

export type ReportOrderStatusOrSentinel =
  | ReportOrderStatus
  | typeof NO_BACKOFF_RESULT;

export const ReportOrderFinalStatusList = [
  NO_BACKOFF_RESULT,
  ReportOrderStatus.CREATED,
  ReportOrderStatus.ERROR,
];

export enum ReportStatus {
  AVAILABLE = 0,
  NOT_ENOUGH_CASES = 1,
  AVOID_NEGATIVE_SELECTION = 2,
}

export enum ReportKind {
  PREGEN = 'pregen',
  CUSTOM = 'custom',
}

export enum ReportType {
  EMPLOYEE = 0,
  MANAGER = 1,
  ZIP = 2,
  VERBATIM = 3,
  POSTER = 4,
  COMPARISON = 5,
  OPENCOMMENT = 6,
  OPENCOMMENT_TREE_INFO_DECORATED = 26,
  STRUCTURE = 7,
  SCATTER = 8,
  PULS_POSTER_REPORT = 9,
  PULS_RESULT_TABLE = 10,
  SHOWCASE_FOCUSREPORT = 11,
  // Obi Report types 2xx
  OBI_PULS_MANAGER_REPORT = 201,
  OBI_PULS_OEQ_REPORT = 202,
  // GPTW report types 3xx
  GPTW_MANAGER_REPORT = 301,
  GPTW_OEQ_REPORT = 302,
}

export const FILE_TYPE_MAP = {
  [ReportFileType.PDF]: 'pdf',
  [ReportFileType.PPTX]: 'pptx',
  [ReportFileType.ZIP]: 'zip',
  [ReportFileType.XLS]: 'xls',
  [ReportFileType.XLSX]: 'xlsx',
  [ReportFileType.PPT]: 'ppt',
};
Object.freeze(FILE_TYPE_MAP);

export const REPORT_TYPE_MAP: { [key in ReportType]: string } = {
  [ReportType.EMPLOYEE]: 'EMPLOYEE',
  [ReportType.MANAGER]: 'MANAGER',
  [ReportType.ZIP]: 'ZIP',
  [ReportType.VERBATIM]: 'VERBATIM',
  [ReportType.POSTER]: 'POSTER',
  [ReportType.COMPARISON]: 'COMPARISON',
  [ReportType.OPENCOMMENT]: 'OPENCOMMENT',
  [ReportType.OPENCOMMENT_TREE_INFO_DECORATED]: 'OPENCOMMENT',
  [ReportType.STRUCTURE]: 'STRUCTURE',
  [ReportType.SCATTER]: 'SCATTER',
  [ReportType.PULS_POSTER_REPORT]: 'PULS_POSTER_REPORT',
  [ReportType.PULS_RESULT_TABLE]: 'PULS_RESULT_TABLE',
  [ReportType.SHOWCASE_FOCUSREPORT]: 'SHOWCASE_FOCUSREPORT',
  [ReportType.OBI_PULS_MANAGER_REPORT]: 'OBI_PULS_MANAGER_REPORT',
  [ReportType.OBI_PULS_OEQ_REPORT]: 'OBI_PULS_OEQ_REPORT',
  [ReportType.GPTW_MANAGER_REPORT]: 'GPTW_MANAGER_REPORT',
  [ReportType.GPTW_OEQ_REPORT]: 'GPTW_OEQ_REPORT',
};
Object.freeze(FILE_TYPE_MAP);

export const REPORT_STATUS_MAP = [
  {
    id: ReportStatus.AVAILABLE,
    name: 'available',
  },
  {
    id: ReportStatus.NOT_ENOUGH_CASES,
    name: 'notAvailable',
  },
  {
    id: ReportStatus.AVOID_NEGATIVE_SELECTION,
    name: 'notAvailable',
  },
];
Object.freeze(REPORT_STATUS_MAP);

export const ORDER_STATUS_MAP = [
  {
    id: ReportOrderStatus.DRAFT,
    name: 'draft',
  },
  {
    id: ReportOrderStatus.ORDERED,
    name: 'ordered',
  },
  {
    id: ReportOrderStatus.IN_PRODUCTION,
    name: 'inProduction',
  },
  {
    id: ReportOrderStatus.CREATED,
    name: 'done',
  },
  {
    id: ReportOrderStatus.ERROR,
    name: 'error',
  },
];
Object.freeze(ORDER_STATUS_MAP);
